<template>
  <div id="covid19-infantil" class="row">
    <div class="col-md-12">
      <div class="filter-select">
        <vue-select
          :options="microAreas"
          label="micro_area"
          placeholder="Microárea - UBS"
          @input="onChangeMicroArea"
          v-model="selectMicroArea"
        >
          <template slot="option" slot-scope="option">
            {{ option.micro_area }} - {{ option.no_unidade_saude }}
          </template>
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
    </div>
    <div class="col-md-12">
      <div class="info-table">
        <div class="info-table-item">
          <Subtitle
            @exibirVermelhos="handleExibirVermelhos"
            @exibirVerdes="handleExibirVerdes"
            :setRed="setRed"
            :disabledRed="disabledRed"
            :disabledGreen="disabledGreen"
            @resetarNome="setRed = false"
          ></Subtitle>
        </div>
        <div class="info-table-item">
          <download-files
            :callback-pdf="generatePdf"
            :data="displayedCadastros"
            :fields="dataFields"
            name="covid19-infantil"
          >
          </download-files>
        </div>
      </div>
    </div>
    <div class="col-lg-12">
      <tabela-cadastros
        ref="table"
        :cadastros="displayedCadastros"
        :loading="loading"
        @filterSearch="filterSearch($event)"
      ></tabela-cadastros>
    </div>
  </div>
</template>

<script>
import TabelaCadastros from './TabelaCadastros'
import * as Functions from './functions.js'
import * as Filter from './filter.js'
import Subtitle from './Subtitle'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'

export default {
  name: 'Covid19Infantil',
  components: {
    TabelaCadastros,
    Subtitle,
    DownloadFiles,
  },
  data() {
    return {
      cadastros: [],
      nome: '',
      idade_inicial: '',
      idade_final: '',
      loading: false,
      size: '40px',
      color: '#0D98BB',
      equipe: '',
      nomeEquipe: '',
      nomeProfissional: '',
      vacinasRegistradas: [],
      cadastrosOriginais: [],
      setRed: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      disabledRed: false,
      disabledGreen: false,
      situacao_opcoes: [
        {
          situacao: '11 - 12 anos',
        },
        {
          situacao: '13 - 14 anos',
        },
      ],
      situacao: '',
      filterSearchTable: false,
      dataFields: {
        ...Functions.dataFields,
      },
      cadastrosOriginaisEquipe: [],
      microAreas: [],
      selectMicroArea: null,
    }
  },
  computed: {
    displayedCadastros() {
      if (this.filterSearchTable != false) {
        return this.filterSearchTable
      }
      this.cadastros = this.cadastrosOriginais
      let response = Filter.filtro(
        this.cadastros,
        this.selectMicroArea,
        this.exibirCadastrosVermelhos,
        this.exibirCadastrosVerdes
      )
      if (response === undefined) {
        response = []
      }
      return response
    },
  },
  methods: {
    filterSearch(item) {
      if (item.filter !== false) {
        this.filterSearchTable = item.filter
        return
      }
      this.filterSearchTable = false
    },

    handleExibirVermelhos(event) {
      this.loading = true
      this.disabledRed = true
      this.disabledGreen = true
      setTimeout(() => {
        if (event == true) {
          this.exibirCadastrosVermelhos = true
          this.exibirCadastrosVerdes = false
        } else {
          this.exibirCadastrosVermelhos = false
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.loading = false
      }, 1000)
    },

    handleExibirVerdes(event) {
      this.loading = true
      this.disabledGreen = true
      this.disabledRed = true
      setTimeout(() => {
        if (event == true) {
          this.exibirCadastrosVerdes = true
          this.exibirCadastrosVermelhos = false
        } else {
          this.exibirCadastrosVerdes = false
        }
        this.disabledRed = false
        this.disabledGreen = false
        this.loading = false
      }, 1000)
    },

    async buscarDadosIniciais() {
      try {
        this.loading = true
        let user = await this.$api.post('/app/usuario/auth', {
          cod_ibge: this.$store.state.cod_ibge,
          id: this.$store.state.id,
        })
        if (user) {
          this.nomeProfissional = user.data.nome

          // microáreas
          const response_micro_areas = await this.$api.post(
            '/app/acs/microareas',
            {
              co_ibge: this.$store.state.cod_ibge,
              cpf_acs: user.data.cpf,
            }
          )
          this.microAreas = response_micro_areas.data
          const microArea = this.microAreas.find((el) => {
            return el.nu_ine == this.$store.state.nu_ine
          })
          this.selectMicroArea = microArea

          const response = await Functions.getDadosPorMicroarea(
            this.$store.state.cod_ibge,
            this.$store.state.nu_ine,
            microArea.micro_area
          )
          this.cadastrosOriginaisEquipe = response
          this.cadastros = response
          this.cadastrosOriginais = response
          this.setRed = true
          this.exibirCadastrosVermelhos = true
          this.exibirCadastrosVerdes = false
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },

    async onChangeMicroArea(item) {
      if (item != null) {
        this.loading = true
        try {
          const response = await Functions.getDadosPorMicroarea(
            this.$store.state.cod_ibge,
            this.$store.state.nu_ine,
            item.micro_area
          )
          this.cadastros = response
          this.cadastrosOriginais = response
          this.setRed = true
          this.exibirCadastrosVermelhos = true
          this.exibirCadastrosVerdes = false
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      } else {
        this.cadastrosOriginais = this.cadastrosOriginaisEquipe
        this.cadastros = this.cadastrosOriginaisEquipe
        this.setRed = true
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      }
    },

    generatePdf() {
      Functions.generatePdf(
        this.displayedCadastros,
        '',
        this.selectMicroArea != null ? this.selectMicroArea.micro_area : ''
      )
    },
  },
  async created() {
    await this.buscarDadosIniciais()
  },
}
</script>

<style>
#covid19-infantil .select-situacao .vs__dropdown-menu {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  padding: 0px;
}
#covid19-infantil .select-situacao .vs--searchable .vs__dropdown-toggle {
  padding: 5px;
}
#covid19-infantil .select-situacao .v-select {
  width: 296px;
}
#covid19-infantil .select-situacao .vs__dropdown-toggle {
  background-color: #fff;
}
</style>
